<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title" v-if="Tversion == 3">{{$t('充值')}}</div>
            <div v-else>
              <ul class="tab-box">
                  <li class="tab" :class="{active: tabIdx == 0}" @click="tab(0)">{{$t('充值')}}</li>
                  <li class="tab" :class="{active: tabIdx == 1}" @click="tab(1)">{{$t('提现')}}</li>
                  <li class="tab" :class="{active: tabIdx == 2}" @click="tab(2)">{{$t('langNew3.gd')}}</li>
              </ul>
            </div>
            <span class="text2"></span>
        </div>
        <div class="cotainer">
            <ul class="item-box" @scroll="listenScroll">
                <template>
                  <div class="list" v-for="(item,k) in list" :key="k">
                    <div class="line1">
                      <span class="text1" v-if="tabIdx!=2">{{ item.currency }}
                        <template v-if="tabIdx==0">{{$t("充值")}}</template>
                        <template v-else-if="tabIdx == 1">{{$t("提现")}}</template>
                        <template v-else>{{$t("充值")}}</template>
                      </span>
                      <span class="text1 ellipse" v-else>{{item.manager}}</span>
                      <span class="text2" v-if="tabIdx!=2" :class="{under: item.status == 1}">{{item.status | status}}</span>
                      <span class="text2" v-else :class="{under: item.order_status == 30}">{{item.order_status | status2}}</span>
                    </div>
                    <div class="line3">
                      <div class="textb">
                        <span class="text1">{{$t("申请时间")}}</span>
                        <span class="text2" v-if="tabIdx == 2">{{ times2(item.start_time) }}</span>
                        <span class="text2" v-else>{{ times2(item.add_time) }}</span>
                      </div>
                      <div class="textb" v-show="tabIdx != 2">
                        <span class="text1">{{$t("接收数量")}}</span>
                        <span class="text2">{{ item.money }}{{ item.currency }}</span>
                      </div>
                      <div class="textb" v-if="tabIdx==1">
                        <span class="text1">{{$t("手续费")}}</span>
                        <span class="text2">{{item.service_charge}} USDT</span>
                      </div>
                      <div class="textb" v-if="tabIdx==2">
                        <span class="text1">{{$t("金额")}}</span>
                        <span class="text2">{{item.amount}} USDT</span>
                      </div>
                      <div class="textb" v-if="tabIdx==2">
                        <span class="text1">{{$t("langNew3.zdf")}}</span>
                        <span class="text2">{{item.true_profit}}%</span>
                      </div>
                      <div class="textb" v-if="tabIdx==2">
                        <span class="text1">{{$t("jghy.sy")}}</span>
                        <span class="text2">{{item | dayRate }} USDT</span>
                      </div>
                    </div>
                    <div class="gd-btn" v-show="tabIdx == 2 && item.order_status == 30" @click="stop(item.id)">{{$t('langNew3.tz')}}</div>
                  </div>
                </template>
                <!-- 暂无数据 -->
                <div class="null-box" v-show="isNoData">
                    <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                    <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                    <p class="text">{{$t('zwsj.title')}}</p>
                </div>
            </ul>
            <!-- 返回顶部 -->
            <img id="goTop" v-if="theme" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/theme/goTop_white.png" alt="">
            <img id="goTop" v-else class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/goTop.png" alt="">
        </div>
    </div>
</template>

<script>
let that = this;
export default {
    name: 'records',
    data () {
        return {
            tabIdx: 0,
            isNoData: false,
            list: [],
            statusText: [],
            isGoTOP: false,
            curDataLength: 10,
            theme: false,
            page: 1
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        this.tabIdx = this.$route.query.type || 0;
        this.statusText = this.$t('status.statusText');
        this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
        this.getMyLog()
    },
    methods: {
       back(){
           this.$router.go(-1);
       },
       stop(id){
         let params = {
          id: id
        }
        this.$ajax.post('/web/strategySell',params).then((res) => {
          let resData = res.data;
          if(resData.code == 1){
            this.$toast.center(resData.message);
          }else if(resData.code == 1000){
            this.$toast.center(resData.message);
          }else{
            this.page = 1;
            this.list = [];
            this.tabIdx = 2;
            this.$toast.center(resData.message);
            this.getMyLog();
          }
        }).catch(function(err){
            console.log(err)
        })
       },
       getMyLog(){
          var url;
          if(this.tabIdx == 0){
            url = '/web/rechargeLog';
          }else if(this.tabIdx == 1){
            url = '/web/takeLog';
          }else{
            url = '/web/strategyOrder';
          }
          let params = {
              page: this.page
          }
          this.$ajax.get(url,{params}).then((res) => {
            if(res.data.code == 1000){
              this.$router.push('/login')
            }
            if(this.tabIdx == 2){
              var resData = res.data.data.list;
            }else{
              var resData = res.data.data.data;
            }
            if(resData.length > 0){
                this.list = this.list.concat(resData);
                this.curDataLength = resData.length;
            }else{
                this.curDataLength = resData.length;
            }
            if(this.list.length > 0){
                this.isNoData = false;
            }else{
                this.isNoData = true;
            }
          }).catch(function(err){
              console.log(err)
          })
       },
       listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 200){
                this.isGoTOP = true
            }else{
                this.isGoTOP = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getMyLog();
                }
            }
        },
       tab(idx){
           this.tabIdx = idx;
           this.list = [];
           this.getMyLog();
       },
       goTop(){
           $('.item-box').animate({scrollTop:'0px'},'slow');
       },
       times2(timess){
         var date = new Date(timess * 1000);
         var Y = date.getFullYear() + '-';
         var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
         var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
         let h = date.getHours()<10?'0'+date.getHours():date.getHours();
         let m = date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes();
         let s = date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds();
         return Y + M + D + ' ' +h+':'+m+':'+s;
       },
    },
    beforeDestroy(){

    },
    filters: {
      status: function(val){
        if(val == -1){
            return that.statusText[0]
        }else if(val == 0){
            return that.statusText[1]
        }else if(val == 1){
            return that.statusText[2]
        }else{
            return that.statusText[0]
        }
      },
      dayRate: function(val){
        if(val.day == 3){
          return val.day3_profit * 0.01 * val.amount;
        }else if(val.day == 7){
          return val.day7_profit * 0.01 * val.amount;
        }else if(val.day == 14){
          return val.day14_profit * 0.01 * val.amount;
        }else if(val.day == 30){
          return val.day30_profit * 0.01 * val.amount;
        }else if(val.day == 60){
          return val.day60_profit * 0.01 * val.amount;
        }else if(val.day == 180){
          return val.day180_profit * 0.01 * val.amount;
        }else{
          return val.day3_profit * 0.01 * val.amount;
        }
      },
      status2: function(val){
        if(val == 30){
            return that.$t('langNew2.jxz')
        }else if(val == 100){
            return that.$t('ieo.yjs')
        }else{
          return that.$t('gjrz.shz')
        }
      }
    },
}
</script>
<style scoped>
    .head{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.4rem 0.5rem;
      color: #000;
      background: #fff;
    }
    .head .back{
        width: .4rem;
        height: 0.6rem;
    }
    .head .text2{width: 0.5rem;}
    .head .title{
        font-size: .56rem;
    }
    .cotainer{
        position: absolute;
        top: 1.4rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .item-box{
        background: #fff;
    }
    .cotainer .item-box .item{
        display: flex;
        align-items: stretch;
        padding: .6rem .3rem 0 .3rem;
    }
    .cotainer .item-box .item .img{
        width: .68rem;
        height: .68rem;
        margin-right: .3rem;
    }
    .cotainer .item-box .item .item-right{
        flex: 1;
        padding-bottom: .4rem;
        border-bottom: 1px solid #ececec;
    }
    .cotainer .item-box .item .item-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .cotainer .item-box .item .t1{
        color: #000;
        font-size: .48rem;
    }
    .cotainer .item-box .item .t2{
        color: #000;
        font-size: .56rem;
        text-align: right;
    }
    .cotainer .item-box .item .time{
        padding-top: .36rem;
        color: #797979;
        font-size: .34rem;
    }
    .cotainer .item-box .item .status{
        padding-top: .36rem;
        color: #575757;
        font-size: .34rem;
        text-align: right;
    }
    .cotainer .item-box .item .under{
        color: #588bf8;
    }
    .cotainer .item-box .item:last-child .item-right{
        border-bottom: none;
    }
    .cotainer .item-box .item .remark{
        color: #000;
        font-size: .36rem;
        padding: .24rem 0 0;
    }
</style>
<style type="text/css" lang="less" scoped>
  .head{
    .tab-box{display: inline-block;padding: 0.1rem;background-color: #f5f6f8;border-radius: 5px;
      .tab{display: inline-block;padding: 0.15rem 0.4rem;border-radius: 5px;font-size: 0.4rem;}
      .active{background-color: #fff;}
    }
  }
  .cotainer{
    .item-box{
      .list{padding: 0.4rem 0.5rem;border-radius: 8px;background-color: #fff;box-shadow: 0 0 5px 3px #00000020;
        margin: 0.5rem;
        .line1{display: flex;justify-content: space-between;
          .text1{font-size: 0.45rem;font-weight: bold;color: #555;padding-bottom: 0.1rem;}
          .text2{font-size: 0.4rem;color: #4458ed;}
          .under{
            color: #909090;
          }
        }
        .line2{font-size: 0.37rem;color: #999;margin-bottom: 0.35rem;}
        .line3{
          .textb{display: flex;justify-content: space-between;font-size: 0.37rem;margin: 0.4rem 0 0;
            .text1{color: #999;}
            .text2{color: #555;}
          }
        }
      }
    }
  }
  .gd-btn{
    height: 1.1rem;
    margin-top: .8rem;
    color: #fff;
    font-size: .38rem;
    line-height: 1.1rem;
    background: #4458ed;
    border-radius: 0.58rem;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/pages/records.vue